class Popup {
    constructor() {
        this.DOM = {
            body: document.body,
            linksOpenPopup: document.querySelectorAll('.js-open-popup'),
            linksOpenPopupHref: document.querySelectorAll('a[href*="?popup="]'),
            linksClosePopup: document.querySelectorAll('.js-close-popup'),
            popupOverlay: document.querySelector('.popup-overlay')
        };

        this.setEventListeners();
        this.openPopupFromUrl();

        // Open popup by id, for testing
        // this.openPopupById('popup-product-test');
    }

    setEventListeners() {
        this.DOM.linksOpenPopup.forEach((el) => {
            el.addEventListener('click', (event) => this.openPopup(event));
        });

        this.DOM.linksOpenPopupHref.forEach((el) => {
            el.addEventListener('click', (event) => this.openPopupHref(event));
        });

        this.DOM.linksClosePopup.forEach((el) => {
            el.addEventListener('click', (event) => this.closePopup(event));
        });

        if (this.DOM.popupOverlay) {
            this.DOM.popupOverlay.addEventListener('click', () => this.closePopupOverlay());
        }

        // Catch custom popup event
        // Example: document.dispatchEvent(new CustomEvent('openPopup', {detail: { popupId: 'popup-example' }}));
        document.addEventListener('openPopup', (event) => {
            const popupId = event.detail.popupId;
            console.log('openPopup custom event', popupId);
            if (popupId) {
                this.openPopupById(popupId);
            }
        });
    }

    openPopupFromUrl() {
        const url = new URL(window.location.href);
        const popupId = url.searchParams.get('popup');

        if (popupId) {
            this.openPopupById(popupId);
        }
    }

    openPopup(event) {
        const popupId = event.target.dataset.popup_id;
        this.openPopupById(popupId);
    }

    openPopupHref(event) {
        event.preventDefault();
        const href = event.target.href;
        const url = new URL(href);
        const popupId = url.searchParams.get('popup');
        if (popupId) {
            setTimeout(() => {
                this.openPopupById(popupId);
            }, 250);
        }
    }

    openPopupById(popupId) {
        console.log('openPopupById :', popupId);

        const popupElement = document.querySelector(`.popup[data-popup_id="${popupId}"]`);
        if (popupElement) {
            if (window.scrollObject.scrollSmoother) {
                window.scrollObject.scrollSmoother.stop();
            }
            this.DOM.body.classList.add('show-popup-overlay');
            popupElement.classList.add('open');
        }
    }

    closePopup(event) {
        const popupId = event.target.dataset.popup_id;
        this.closePopupById(popupId);
        if (window.scrollObject.scrollSmoother) {
            window.scrollObject.scrollSmoother.start();
        }
        this.DOM.body.classList.remove('show-popup-overlay');
    }

    closePopupById(popupId) {
        this.DOM.body.classList.remove('show-popup-overlay');
        const popupElement = document.querySelector(`.popup[data-popup_id="${popupId}"]`);
        popupElement.classList.remove('open');
    }

    closePopupOverlay() {
        if (window.scrollObject.scrollSmoother) {
            window.scrollObject.scrollSmoother.start();
        }
        this.DOM.body.classList.remove('show-popup-overlay');
        const popupElement = document.querySelector(`.popup.open`);
        popupElement.classList.remove('open');
    }
}

new Popup();
